/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useFreezeBody } from '@lt/components/hooks';
import type { RefObject } from 'react';
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import type { ExtendedHotelInfo } from 'src/components/YandexMap/types';
import { useSwipePopup } from 'src/hooks/useSwipePopup';
import { pushHotelClicked, pushMapHotelCardPopup } from '../../analytics';
import HotelRenderer from '../../../HotelRenderer';

import styles from './hotelPopup.module.css';

type HotelPopupProps = {
  isMobile: boolean;
  popupData?: ExtendedHotelInfo;
  popupRef: RefObject<HTMLDivElement>;
  isExpandable: boolean;
  isExpanded: boolean;
  onClosePopup: () => void;
};

type AnimationState = 'opening' | 'closing';

const HotelPopup = (props: HotelPopupProps) => {
  const {
    isMobile,
    popupData,
    popupRef,
    isExpandable,
    isExpanded,
    onClosePopup,
  } = props;
  const [animation, setAnimation] = useState<AnimationState>('opening');

  const onClose = () => {
    setTimeout(() => {
      onClosePopup();
      resetPopup();
      setAnimation('opening');
    }, 300);

    setAnimation('closing');
  };

  const { delta, resetPopup } = useSwipePopup({
    ref: popupRef,
    onSwipe: onClose,
  });

  const { setIsFreeze } = useFreezeBody();
  useEffect(() => {
    if (isMobile) setIsFreeze(Boolean(popupData));
  }, [popupData, setIsFreeze, isMobile]);

  useEffect(() => {
    if (popupData?.state) {
      pushMapHotelCardPopup(isMobile, popupData.state);
    }
  }, [popupData, isMobile]);
  if (!popupData && animation !== 'closing') return null;

  return (
    <div
      className={classnames({
        [styles.popupWrapper]: !isMobile,
        [styles.openingPopupWrapper]: animation === 'opening',
        [styles.closingPopupWrapper]: animation === 'closing',
        [styles.mobilePopupWrapper]: isMobile,
        [styles.collapsedPopupWrapper]:
          !isMobile && !isExpanded && isExpandable,
      })}
      style={{ bottom: -delta }}
      ref={popupRef}
      onClick={() => pushHotelClicked()}
    >
      {popupData && popupData.hotelInfo ? (
        <HotelRenderer
          isMobile={isMobile}
          isMapCard
          onCloseMapPopup={onClose}
          {...popupData.hotelInfo}
        />
      ) : null}
    </div>
  );
};

export default HotelPopup;
